import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetPartnersMutation } from '../apis';
import type { PartnerQueryLinkerSchema } from '../schemas';

export function PartnersSelect({ disabled, itemToString, ...props }: FormComboboxProps<PartnerQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: PartnerQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/partners/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={itemToString ?? getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetPartnersMutation}
      disabled={disabled}
    />
  );
}
